import React, { useLayoutEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Footer from '../../Components/Footer';
import MobileFooter from '../../Components/mobileFooter';
import Header from '../../Components/MockupHeader/index';
import './Mockup.scss';
import { useAccountState, getTripSettings, useDriverNotificationsState } from '../../Context';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useHistory } from 'react-router-dom';
import MobileHeader from '../../Components/MobileMockupHeader/index';
import { getUnreadNotificationsCount } from '../../Context/actions/driverNotificationsActions';

const DEFAULT_FOOTER_LOGO =
    'https://storage.googleapis.com/the-bus-network-bucket/account-settings/large-powered-by-white_FApW7.png';

const Mockup = ({ children, mobileAndTabletCheck }) => {
    const {
        AccountsDispatch,
        tripSettings: { tripSettings },
    } = useAccountState();
    const {
        notificationsDispatch,
        notifications: { unreadCount },
    } = useDriverNotificationsState();
    const [loading, setLoading] = useState(false);
    const navigate = useHistory();

    useLayoutEffect(() => {
        (async function () {
            setLoading(true);
            await getTripSettings(AccountsDispatch);
            await getUnreadNotificationsCount(notificationsDispatch);
            setLoading(false);
        })();
    }, [AccountsDispatch]);

    const MenuItems = [
        {
            name: 'Assignments',
            children: [],
            icon: 'fa-calendar',
            active: true,
            webUrl: '/driver/assignments',
            path: '/driver/assignments',
            isEnabled: true,
            uuid: '9f8db025-bec6-45a7-8c9e-f58c7e12662b',
        },
        {
            name: 'Schedule',
            children: [],
            icon: 'fa-clock-o',
            active: true,
            webUrl: '/driver/schedule',
            path: '/driver/schedule',
            isEnabled: true,
            uuid: 'c2a4f1b3-7de8-4a90-b5c1-3f8e2d9a1047',
        },
        {
            name: 'Messages',
            children: [],
            icon: 'fa-comment ',
            active: true,
            webUrl: '/driver/notifications',
            path: '/driver/notifications',
            isEnabled: true,
            badgeInfo: unreadCount > 0 ? unreadCount : null,
            uuid: '3109779d-00de-4e51-8ea3-f92e3935f41a',
        },
        {
            name: 'Profile',
            children: [],
            icon: 'fa-user ',
            active: true,
            webUrl: '/driver/profile',
            path: '/driver/profile',
            isEnabled: true,
            uuid: '9bf95200-613b-40d9-a130-ec1fe779b6e5',
        },
    ];
    return (
        <>
            <div>
                <Container fluid className="p-0 fullHeight">
                    {!mobileAndTabletCheck ? <Header menuItems={MenuItems} /> : <MobileHeader menuItems={MenuItems} />}

                    {mobileAndTabletCheck && (
                        <Tabs defaultActiveKey="Calendar" id="uncontrolled-tab-example">
                            <Tab
                                eventKey="Calendar"
                                title="Calendar"
                                onEnter={() => {
                                    navigate.push(`/driver/assignments`);
                                }}
                            ></Tab>
                            <Tab
                                eventKey="Schedule"
                                title="Schedule"
                                onEnter={() => {
                                    navigate.push(`/driver/schedule`);
                                }}
                            ></Tab>
                            <Tab
                                eventKey="Messages"
                                title={`Messages ${unreadCount > 0 ? `(${unreadCount})` : ''}`}
                                onEnter={() => {
                                    navigate.push(`/driver/notifications`);
                                }}
                            ></Tab>
                            <Tab
                                eventKey="Profile"
                                title="Profile"
                                onEnter={() => {
                                    navigate.push(`/driver/profile`);
                                }}
                            ></Tab>
                        </Tabs>
                    )}
                    {children}
                    {!mobileAndTabletCheck ? (
                        <Footer
                            fixed={false}
                            logo={tripSettings?.companyLogoUrl || DEFAULT_FOOTER_LOGO}
                            loading={loading}
                            mainColor={tripSettings?.mainColor}
                        />
                    ) : (
                        <MobileFooter
                            fixed={true}
                            logo={tripSettings?.companyLogoUrl || DEFAULT_FOOTER_LOGO}
                            loading={loading}
                            mainColor={tripSettings?.mainColor}
                        />
                    )}
                </Container>
            </div>
        </>
    );
};

export default Mockup;
